import { createContext, useContext } from 'react';
import { TableActionContextData as ContextData } from './types';

const context = createContext<ContextData>({} as ContextData);

export const { Provider } = context;

export const useTableActionContext = () => useContext(context);
